import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterCasinoReport from 'views/reports/pokerReport/filterCasinoReport'; // Importing filter component for casino report
import TableCasinoReport from 'views/reports/pokerReport/tableCasinoReport'; // Importing table component for casino report
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Casino Report View.
 * @extends JetView
 */
export default class CasinoReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const vthis = this; // Reference to the current instance

        // Toolbar configuration for pagination and export options
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar1',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select',
                    id: 'select',
                    options: ['10', '20', '50', '100', '1000'], // Options for number of items per page
                    width: 70,
                    on: {
                        onChange: function () {
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the data table
                            $$('datatable').scrollTo(100, 0); // Scroll to the top of the table
                        },
                    },
                },
                {
                    view: 'pager',
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export1',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export select
                    options: [
                        { id: '1', value: 'Excel' }, // Export to Excel option
                        { id: '2', value: 'PDF' }, // Export to PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            var table = $$('datatable'); // Reference to the data table
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // Calculate first item index
                            var last = first + size - 1; // Calculate last item index
                            if (value !== '') {
                                vthis.app.callEvent('export:filter', [
                                    { value: value, first: first, last: last }, // Trigger export event with parameters
                                ]);
                            }
                        },
                    },
                },
            ],
        };

        // Second toolbar configuration for export options
        const toolbar2 = {
            view: 'toolbar',
            id: 'toolbar2',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {},
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export2',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export select
                    options: [
                        { id: '1', value: 'Excel' }, // Export to Excel option
                        { id: '2', value: 'PDF' }, // Export to PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable2'); // Reference to the second data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        table.config.columns[j].format2 = table.config.columns[j].format; // Store original format
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) + 'Poker', // Report name
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix
                                    .toExcel(table, {
                                        // Export to Excel
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            new Date().toLocaleString() +
                                            ' - ' +
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Poker',
                                        ignore: {
                                            detailTittle: true,
                                            Type: true,
                                        },
                                        footer: false,
                                    })
                                    .then(() => {
                                        for (var j = 0; j < table.config.columns.length; j++) {
                                            if (table.config.columns[j].exportType) {
                                                table.config.columns[j].format = table.config.columns[j].format2; // Restore original format
                                            }
                                        }
                                    });
                            } else if (value == 2) {
                                // If PDF is selected
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) + 'Poker', // Report name
                                        TypeReport: 'PDF', // Report type
                                    },
                                ]);
                                webix.toPDF($$('datatable2'), {
                                    // Export to PDF
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        new Date().toLocaleString() +
                                        ' - ' +
                                        ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Poker',
                                    autowidth: true,
                                    ignore: {
                                        detailTittle: true,
                                        Type: true,
                                    },
                                    footer: false,
                                });
                            }
                            $$('Export2').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };

        // Left side configuration containing toolbars and reports
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply current theme
                    elements: [
                        { view: 'label', label: _('Reporte de Poker') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                    ],
                },
                FilterCasinoReport, // Filter component
                TableCasinoReport, // Table component
                toolbar, // First toolbar
                toolbar2, // Second toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left, { id: 'res', view: 'resizer' }], // Layout with left side and resizer
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button on larger screens
            }
            if (screen.width < 500 || screen.height < 500) {
                $$('res').hide(); // Hide resizer on smaller screens
                var childs = $$('toolbar1').getChildViews();
                $$('toolbar1').removeView(childs[2]); // Remove export select from toolbar
                $$('pagerA').define('group', 1); // Define pager group
            }
            $.fn.scrollBottom = function () {
                return $(document).height() - this.scrollTop() - this.height(); // Custom scroll bottom function
            };
        });
    }
}

// FILE DOCUMENTED
